"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.fields = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _cccisdVideo = require("cccisd-video");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = exports.fields = ['id', 'contentType', 'text'].concat(_toConsumableArray(_cccisdVideo.builderFields.map(function (field) {
  return "video.".concat(field);
})));
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (values.contentType === 'video') {
    errors.video = (0, _cccisdVideo.builderValidate)(values.video);
  }
  return {};
};
var Component = function Component(props) {
  var _props$fields = props.fields,
    text = _props$fields.text,
    contentType = _props$fields.contentType,
    video = _props$fields.video;
  var contentTypeOptions = [{
    value: 'text',
    label: 'Text'
  }, {
    value: 'video',
    label: 'Video'
  }];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Content type"), /*#__PURE__*/_react["default"].createElement("div", null, contentTypeOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("label", {
      key: option.value,
      className: "radio-inline"
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({
      type: "radio"
    }, (0, _domOnlyProps["default"])(contentType), {
      value: option.value,
      checked: contentType.value === option.value
    })), ' ', option.label);
  }))), contentType.value === 'text' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _common["default"].lastRow
  }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
    label: "Text",
    field: text,
    isWysiwyg: true,
    wysiwygProps: {
      type: 'textarea-inline'
    }
  })) : /*#__PURE__*/_react["default"].createElement(_cccisdVideo.Builder, {
    fields: video,
    isIncludedMode: true
  }));
};
Component.propTypes = {
  fields: _propTypes["default"].object
};
var _default = exports["default"] = {
  name: 'Item',
  component: Component,
  validate: validate,
  fields: fields,
  initialValues: {
    contentType: 'text',
    text: 'Item description',
    video: _objectSpread({}, _cccisdVideo.builderInitialValues)
  }
};